import { ConnectionDetails, convertConnectionToDetails, handleError } from '@/utils/custom';
import { QueryHistory, QueryHistoryConnection, QueryHistoryConnectionInput, QueryHistorySearch } from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { SearchQueryHistoryDocument } from '@/api/queries';
import graphApi from '@/api';

export type SearchQueryHistoryGraphApiResponse = GraphApiResponse<typeof SearchQueryHistoryDocument>;
export type SearchQueryHistoryOptions = { pageSize?: number; page?: number; merge?: true };

export const SEARCH_QUERY_HISTORY_PAGE_SIZE = 1000;
const title = 'Search Query History';

export const searchQueryHistoryResponseSelector = (res: SearchQueryHistoryGraphApiResponse): ConnectionDetails<QueryHistory> =>
  convertConnectionToDetails(res?.searchQueryHistory?.queryHistoryConnection as QueryHistoryConnection);

const [runSearchQueryHistory, runRefetchSearchQueryHistory] = graphApi(SearchQueryHistoryDocument, {
  onError: (res: SearchQueryHistoryGraphApiResponse): void => handleError(res, { notification: { title } }),
});

export const searchQueryHistory = async (
  query?: QueryHistorySearch[],
  options: SearchQueryHistoryOptions = {}
): Promise<ConnectionDetails<QueryHistory>> => {
  const { pageSize = SEARCH_QUERY_HISTORY_PAGE_SIZE, page = 0 } = options;

  const input: QueryHistoryConnectionInput = {
    first: pageSize || null,
    after: pageSize ? (pageSize * page).toString() : null,
    query,
  };

  const res = await runRefetchSearchQueryHistory({ input });

  return searchQueryHistoryResponseSelector(res);
};

export default searchQueryHistory;
